'use client';

import { MessageContextDetails } from '@/@studio-ai/components/message-context-details';
import { ContextDataEntry } from '@/@studio-ai/types';

interface ContextDividerProps {
    contextEntry: ContextDataEntry;
    className?: string;
}

export function ContextDivider({ contextEntry, className = '' }: ContextDividerProps) {
    return (
        <div className={`mx-auto w-full max-w-3xl px-4 py-1 ${className}`}>
            <MessageContextDetails contextEntry={contextEntry} />
        </div>
    );
}
